export default __webpack_public_path__ + "static/media/library-menu-icon.20372deb.svg";